// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Page components
import Signin from './pages/signin';
import Agents from './pages/agents';
import Payments from './pages/payments';
import AdManagement from './pages/ad-management';
import Dashboarda from './pages/dashboarda';
import Ranking from './pages/ranking';
import Error404 from './pages/404';
import EditAdPage from './pages/edit-ad';
import CalendarAdsManagement from './pages/calendar';
import EdsaaSMSSender from './pages/sms';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Signin />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/ad-management" element={<AdManagement />} />
        <Route path="/dashboarda" element={<Dashboarda />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/edit-ad" element={<EditAdPage />} />

        
        <Route path="/calendar" element={<CalendarAdsManagement />} />
        <Route path="/sms" element={<EdsaaSMSSender />} />

        
        {/* Catch-all route for undefined paths */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;